/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/display-name */
import React from "react"
import {
  FaLinkedinIn,
  FaTwitter,
  FaFacebookF,
} from "react-icons/fa"
import { VscGithub } from "react-icons/vsc"

const data = [
  {
    id: 1,
    icon: <FaFacebookF className="social-icon"></FaFacebookF>,
    url: "https://www.facebook.com/frederick.tetteh29",
  },
  {
    id: 2,
    icon: <FaLinkedinIn className="social-icon"></FaLinkedinIn>,
    url: "https://www.linkedin.com/in/frederick-tetteh/",
  },
  {
    id: 3,
    icon: <VscGithub className="social-icon"></VscGithub>,
    url: "https://github.com/just-kwesi",
  },
  {
    id: 4,
    icon: <FaTwitter className="social-icon"></FaTwitter>,
    url: "https://twitter.com/Fhred_rick",
  },
]
const links = data.map(link => {
  return (
    <li key={link.id}>
      <a
        href={link.url}
        target="_blank"
        rel="noreferrer"
        className="social-link"
      >
        {link.icon}
      </a>
    </li>
  )
})

export default ({ styleClass }) => {
  return (
    <ul className={`social-links ${styleClass ? styleClass : ""}`}>{links}</ul>
  )
}
